import { useEffect, useState } from 'react'
import { getDatosContrato } from '@/common/utils/services/contratos.service'
import { getContrato } from '@/auth/auth.utils'
import { useAuthStore } from '@/common/zustand/store/auth.store'

/**
 * Contrato y razón social de la cuenta con la que opera la sesión.
 *
 * El Admin ART/HyS no tiene la cuenta activa en una lista propia, así que la
 * razón social se pide al servicio de company, igual que en Mi perfil.
 * Sin contrato activo no se hace ningún pedido.
 *
 * @returns {{ contratoActivo: string|number|null, razonSocial: string }}
 */
export const useCuentaActiva = () => {
  const contratoStore = useAuthStore((s) => s.contrato)
  const contratoActivo = contratoStore ?? getContrato() ?? null

  const [razonSocial, setRazonSocial] = useState('')

  useEffect(() => {
    if (!contratoActivo) {
      setRazonSocial('')
      return undefined
    }

    let cancelado = false

    const cargar = async () => {
      const resultado = await getDatosContrato(contratoActivo)
      if (cancelado) return
      setRazonSocial(resultado.code === 200 ? resultado.data?.NOMBREEMPRESA || '' : '')
    }

    cargar()

    return () => {
      cancelado = true
    }
  }, [contratoActivo])

  return { contratoActivo, razonSocial }
}
